<template>
  <div class="modal micromodal-slide" aria-hidden="true" id="modal-1" :class="{ 'is-open': selectItemIsOpen }">
    <div class="bg modal__overlay" v-on:click="closeItemDetail()"></div>
    <div class="modal_item">
      <button v-on:click="closeItemDetail()" class="close"><span class="close_image"><img src="../../assets/images/close.png" alt=""></span></button>
      <div class="scroll" ref="modal__content">
        <div class="item_wrap">
          <!-- <div class="item_image"><img v-bind:src="selectItem.image" :alt="selectItem.productName" v-on:error="imageError"></div> -->
          <div class="item_image"><img :src="setImagePath()" v-on:error="imageError" :alt="selectItem.product.productName"></div>
          <div class="item_contents">
            <h3 class="item_title ab c5a">{{ getProductName() }}</h3>
            <div class="price_wrap">
              <p class="item_price rb c5a"><span class="yen ab">￥</span>{{ selectItem.product.price }}</p>
              <p v-if="selectItem.product.point != 0" class="item_point rb c5a"><span class="point_text ab">ポイント：</span>{{ selectItem.product.point }}<span class="point ab">pt</span></p>
            </div>
          </div>
        </div>
        <div class="manth_wrap">
          <div class="month_item">
            <p class="month ab c5a" v-if="selectItem.currentOrderMonth != 0"><span class="month_number rb">{{ selectItem.currentOrderMonth }}</span>月</p>
            <p class="month" style="border-bottom: none;" v-else></p>
            <div class="count_wrap">
              <span class="count ab c5a">数量</span>
              <div class="select_wrap">
                <select name="buy_count" id="" v-bind:data-count-id="'buyCount0'" class="select_count rb" v-model="itemCount1">
                  <option v-for="n of selectItem.product.maxCount + 1" :value="n - 1">{{ n - 1 }}</option>
                </select>
              </div>
            </div>
          </div>

          <div v-if="selectItem.nextOrderMonth != 0" class="month_item">
            <p class="month ab c5a"><span class="month_number rb">{{ selectItem.nextOrderMonth }}</span>月</p>
            <div class="count_wrap">
              <span class="count ab c5a">数量</span>
              <div class="select_wrap">
                <select name="buy_count" id="" v-bind:data-count-id="'buyCount1'" class="select_count rb" v-model="itemCount2">
                  <option v-for="n of selectItem.product.maxCount + 1" :value="n - 1">{{ n - 1 }}</option>
                </select>
              </div>

            </div>
          </div>
        </div>
        <div v-if="selectItem.product.selectableChildFund" class="kodomo_wrap">
          <input class="kodomo_check" type="checkbox" id="kodomo" name="checkbox01" v-model="child">
          <label for="kodomo" class="checkbox01 ab c5a">こども基金を支援する</label>
        </div>
        <button v-on:click="addCart()" class="btn_blue insert_btn" type="button" name="button">カートに入れる</button>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import scrollPosition from '@/model/scrollPosition';
import Config from '@/config/config'
import ProductFunction from '@/model/n-selection/selectProducts'

export default {
  props: ['selectItem', 'isOpen'],
  data() {
    return {
      child: false,
      itemCount1: 0,
      itemCount2: 0
    }
  },
  methods: {
    setImagePath() {
      if(this.selectItem == null || this.selectItem.product.imagePath == null) return '';
      return Config.APIURL + this.selectItem.product.imagePath;
    },
    imageError(e) {
      e.target.src = Config.APIURL + this.selectItem.product.noImagePath;
    },
    getProductName() {
      if(this.selectItem.product == null) return '';
      return this.selectItem.product.productName;
    },
    closeItemDetail() {
      this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      this.child = false;
      this.itemCount1 = 0;
      this.itemCount2 = 0;
      this.$store.commit('nselection/setSelectItemIsOpen', false);
    },
    addCart() {
      console.log(this.selectItem);
      this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      if (this.itemCount1 == 0 && this.itemCount2 == 0) {
        // 注文数が0の場合処理終了
        return false;
      }
      const data = ProductFunction.createPurchaseOrderItemList(this.selectItem, this.currentMonth, this.itemCount1, this.itemCount2);
      // カートに商品がなければ追加
      let duplication = this.nselectionOrderList.some(({productId}) => productId == data.productId);
      if(!duplication) {
        this.$store.dispatch('nselection/calcCartCount', { status: 'add' });
      }
      this.$store.commit('nselection/setNselectionOrderList', data);
      this.$store.commit('nselection/setSelectItemIsOpen', false);
      this.closeItemDetail();
    },
    initializedCount() {
      this.itemCount1 = 0;
      this.itemCount2 = 0;
    },
    setItemCount() {
      const index = this.nselectionOrderList.findIndex(({productId}) => productId === this.selectItem.product.productId);
      if(index != -1) {
        if('orderMonth' in this.nselectionOrderList[index].purchaseOrderItemList[0]) {
          if(this.nselectionOrderList[index].purchaseOrderItemList[0].orderMonth == this.selectItem.currentOrderMonth) {
            this.itemCount1 = this.nselectionOrderList[index].purchaseOrderItemList[0].orderCount;
          } else {
            this.itemCount1 = 0;
          }
        }
        if('orderMonth' in this.nselectionOrderList[index].purchaseOrderItemList[1]) {
          if(this.nselectionOrderList[index].purchaseOrderItemList[1].orderMonth == this.selectItem.nextOrderMonth) {
            this.itemCount2 = this.nselectionOrderList[index].purchaseOrderItemList[1].orderCount;
          } else {
            this.itemCount2 = 0;
          }
        }
      } else {
        this.initializedCount();
      }
    },
  },
  computed: mapGetters(
    'nselection', ['currentMonth', 'selectItemIsOpen', 'nselectionOrderList'],
  ),
  watch: {
    selectItemIsOpen() {
      if(this.selectItemIsOpen) {
        this.setItemCount();
      }
    },
    selectItem() {
      this.setItemCount();
    },
    nselectionOrderList() {
      // console.log('nselectionOrderList');
      // localStorage.setItem('nselectionOrderList', JSON.stringify(this.nselectionOrderList));
      // this.setItemCount();
    }
  }
}
</script>

<style lang="css" scoped>
.item_image {
  width: 45%;
}
.item_contents {
  width: 55%;
}

.item_price {
  font-size: 40px;
  margin-top: 20px;
}

.yen {
  font-size: 32px;
}

.item_point {
  font-size: 24px;
}

.point_text {
  font-size: 16px;
}

.point {
  font-size: 16px;
}

.manth_wrap {
  margin-top: 54px;
}

.month_item {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
}

.month_item:not(:first-child) {
  margin-top: 19px;
}

.month {
  border-bottom: 1px solid  #c9c9c9;
  font-size: 22px;
  padding-left: 32px;
  position: relative;
  width: 64%;
}

.month::before {
  background-color: #4FCCD4;
  bottom: 0;
  content: '';
  height: 90%;
  left: 16px;
  margin: auto;
  position: absolute;
  top: 0;
  width: 8px;
}

.month_number {
  font-size: 40px;
  margin-right: 4px;
}

.count_wrap {
  align-items: center;
  display: flex;
  width: 35%;
}

.count {
  bottom: -6px;
  font-size: 14px;
  position: relative;
}
.select_wrap {
  border-bottom: 1px solid #5a5a5a;
  margin-left: 2px;
  width: 60%;
}

.select_wrap::after {
  margin-right: 0;
  right: 0;
  top: 7px;
}

.select_count {
  /* border-bottom: 1px solid #5a5a5a; */
  color: #5A5A5A;
  display: block;
  font-size: 26px;
  /* padding-left: 15px; */
  margin-left: auto;
  text-align: left;
  width: 90%;
}

.kodomo_wrap {
  margin-top: 10.7%;
  text-align: center;
}


.item_detail .btn_blue {
  margin-top: 54px;
}


.detail_wrap {
  overflow-y: inherit;
  padding: 80px 0 120px;
}

.item_title {
  font-size: 18px;
  display: flex;
  justify-content: flex-end;
}

.price_wrap {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}

.buy_text {
  width: 60%;
}
.input_number {
  border: none;
  border-bottom: 1px solid #000;
  display: block;
  font-size: 26px;
  padding-right: 5px;
  text-align: right;
  width: 100%;
}
.insert_btn {
  margin-top: 54px;
}
</style>



// WEBPACK FOOTER //
// src/components/n-selection/SelectItem.vue